import FidsPage from "./FidsPage";

export default function FidsT2Page() {
  return (
    <FidsPage
      terminal="KL2"
      terminalName="KUL — KLIA Terminal 2 (KLIA2)"
      terminalLabel="FIDS T2"
    />
  );
}
